import { WeaveThemeValues } from '../../../component-theme/theme-types';
import { PopoverMenuStyles } from './popover-menu.styles';

export type PopoverMenuDividerProps = {
  color?: WeaveThemeValues['Color'];
};
export function PopoverMenuDivider({ color }: PopoverMenuDividerProps) {
  return <div className={PopoverMenuStyles.divider} style={color ? { borderTopColor: color } : undefined} />;
}
